import { render, staticRenderFns } from "./FastVideo.vue?vue&type=template&id=3715e96c&scoped=true&"
import script from "./FastVideo.vue?vue&type=script&lang=js&"
export * from "./FastVideo.vue?vue&type=script&lang=js&"
import style0 from "./FastVideo.vue?vue&type=style&index=0&id=3715e96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3715e96c",
  null
  
)

export default component.exports